// Cliente HTTP (Axios) do site público.
//
// Fala SÓ com o BFF (`bff/`), nunca com a api-lukos direto — ela é privada e
// não abre superfície anônima.
//
// NÃO HÁ INTERCEPTOR DE TOKEN. O visitante é anônimo: não existe login neste
// site. A versão anterior injetava `Authorization` de um `accessToken` em
// sessionStorage, resquício de quando o site tinha admin próprio. Guardar
// token no browser para um site que só lê conteúdo público é superfície de
// ataque sem contrapartida.
import axios from 'axios';
import { appConfig } from '@/config/app.config';

const apiClient = axios.create({
  baseURL: appConfig.apiUrl,
  timeout: appConfig.requestTimeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
